import { useCallback } from "react";
import {
  dispatch,
  IUserSubprofileModel,
  StorageHelper,
  UserStore,
  AuthStore,
} from "@nf/common";
import { ROUTES } from "@nf/constants";
import axios from "axios";

export const useSetCurrentSubProfile = () => {
  return useCallback(async (subProfile?: IUserSubprofileModel) => {
    const remember = await StorageHelper.getCurrentSubprofileId();
    if (subProfile) {
      await axios.post(ROUTES.API_SET_CHILD_COOKIE, {
        isChild: subProfile.Child,
      });
      dispatch(AuthStore.Actions.setIsChild(subProfile.Child));
      dispatch(UserStore.Actions.selectUserSubprofile(subProfile, !!remember));
    }
  }, []);
};
